import React from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import './PopupContent.scss'

export class PopupContent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.overlayRef = React.createRef();
        this.state = {
            target: null
        };
    }

    handleClickOutside = (event) => {
        if (this.props.isActive) {
            if (!!this.overlayRef && !!this.overlayRef.current && !this.overlayRef.current.contains(event.target)) {
                this.props.onToggle(Math.abs(this.props.id));
            }
        }
    }

    render() {
        return (
            <div className="editRowWrapper" ref={this.overlayRef}>
                <div
                    onClick={(event) => {
                        this.setState({ target: event.currentTarget }, () => {
                            this.props.onToggle(Math.abs(this.props.id))
                        });
                    }}>
                    {this.props.button}
                </div>
                <Overlay
                    show={this.props.isActive}
                    target={this.state.target}
                    placement={!!this.props.placement ? this.props.placement : "bottom"}
                    container={this.overlayRef.current}
                    containerPadding={20}
                >
                    <Popover
                        id="hubPopover"
                        placement={this.props.placement}
                        style={this.props.style}> {/* Need to pass props (styles) 
        or else the popup position would get messed up */}
                        <Popover.Title id="hubPopoverTitle" as="h3">
                            {this.props.title}
                        </Popover.Title>
                        <Popover.Content id="hubPopoverContent">
                            {this.props.content}
                        </Popover.Content>
                        <div className="closeButton" onClick={() => this.props.onToggle(this.props.id)}><FontAwesomeIcon icon={faTimes} /></div>
                    </Popover>
                </Overlay>
            </div>
        )
    }
}